import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import JoditEditor from "jodit-react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const CreateBlog = () => {
  const navigate = useNavigate();
  const [postid, setPostId] = useState("");
  const [posttitle, setPostTitle] = useState("");
  const [postheading, setPostHeading] = useState("");
  const [author, setAuthor] = useState("");
  const [content, setContent] = useState("");
  const [featuredimage, setFeaturedimage] = useState("");
  const [featuredicon, setFeaturedicon] = useState("");
  const [category, setCategory] = useState("");
  const [categories, setCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showCreateModal, setShowCreateModal] = useState(false);

  const url = process.env.REACT_APP_API_URL;

  const getCategoryData = async () => {
    const token = localStorage.getItem('jwttoken');
    const headers = { 'x-access-token': token };
    setIsLoading(true);

    try {
      // Trying the primary endpoint from your project structure
      const response = await axios.get(`${url}category/fetchallcategories`, { headers });

      console.log("Database Response for Categories:", response.data);

      if (response.data && response.data.length > 0) {
        setCategories(response.data);
      } else {
        // Fallback to secondary endpoint if first is empty
        const fallback = await axios.get(`${url}category/showAll`, { headers });
        if (fallback.data && fallback.data.length > 0) {
          setCategories(fallback.data);
        } else {
          console.warn("Category table appears to be empty in the database.");
          setCategories([]);
        }
      }
    } catch (error) {
      console.error("API Error:", error.message);
      toast.error("Cloud not connect to Category API");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getCategoryData();
  }, []);

  const handleCreate = async (e) => {
    e.preventDefault();
    setShowCreateModal(false);

    if (!postheading || !content || !category) {
      toast.error("Please provide Heading, Content, and Category", {
        position: "top-center",
        autoClose: 1000,
        theme: "colored",
      });
      return;
    }

    const postData = { postid, posttitle, postheading, author, content, featuredimage, featuredicon, category };

    try {
      const headers = { 'x-access-token': localStorage.getItem('jwttoken') };
      const response = await axios.post(`${url}posts/addNewData`, postData, { headers });
      if (response.status === 201) {
        toast.success("Blog Published!", {
          position: "top-center",
          autoClose: 1500,
          theme: "colored",
        });
        setTimeout(() => navigate("/blogslist"), 2000);
      }
    } catch (err) {
      toast.error("Submission failed. Check backend logs.", {
        position: "top-center",
        autoClose: 1000,
        theme: "colored",
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowCreateModal(true);
  };

  return (
    <>
      <div className="container mt-4">
        <div className="form-card">
          <div className="form-card-header">
            Create New Blog Post
          </div>
          <div className="form-card-body">
            <Form onSubmit={handleSubmit}>

              {/* Row 1: Post ID & Post Title */}
              <Row className="mb-3">
                <Form.Group as={Col} controlId="postid">
                  <Form.Label>Post ID (Auto):</Form.Label>
                  <Form.Control type="text" value={postid} disabled placeholder="Generated by DB" className="bg-light" />
                </Form.Group>
                <Form.Group as={Col} controlId="posttitle">
                  <Form.Label>Post Title (URL Slug):</Form.Label>
                  <Form.Control type="text" value={posttitle} onChange={(e) => setPostTitle(e.target.value)} placeholder="my-blog-post" />
                </Form.Group>
              </Row>

              {/* Row 2: Category & Author */}
              <Row className="mb-3">
                <Form.Group as={Col} controlId="category">
                  <Form.Label>Category:</Form.Label>
                  <Form.Select
                    className={categories.length === 0 ? 'is-invalid' : ''}
                    value={category}
                    onChange={(e) => setCategory(e.target.value)}
                  >
                    <option value="">{isLoading ? "Loading..." : "-- Select Category --"}</option>
                    {categories.map((cat, index) => (
                      <option key={index} value={cat.displayname || cat.categoryname || cat.name}>
                        {cat.displayname || cat.categoryname || cat.name}
                      </option>
                    ))}
                  </Form.Select>
                  {categories.length === 0 && !isLoading && (
                    <div className="text-danger mt-1" style={{ fontSize: '0.85rem' }}>
                      ⚠️ Database returned 0 categories. Please add one in Category CRUD.
                    </div>
                  )}
                </Form.Group>
                <Form.Group as={Col} controlId="author">
                  <Form.Label>Author:</Form.Label>
                  <Form.Control type="text" value={author} onChange={(e) => setAuthor(e.target.value)} />
                </Form.Group>
              </Row>

              {/* Post Heading */}
              <Form.Group className="mb-3" controlId="postheading">
                <Form.Label>Post Heading:</Form.Label>
                <Form.Control type="text" value={postheading} onChange={(e) => setPostHeading(e.target.value)} />
              </Form.Group>

              {/* Content Editor */}
              <Form.Group className="mb-3" controlId="content">
                <Form.Label>Content:</Form.Label>
                <JoditEditor value={content} onChange={(newContent) => setContent(newContent)} />
              </Form.Group>

              {/* Row 3: Featured Image & Icon */}
              <Row className="mb-3">
                <Form.Group as={Col} controlId="featuredimage">
                  <Form.Label>Featured Image URL:</Form.Label>
                  <Form.Control as="textarea" rows={2} value={featuredimage} onChange={(e) => setFeaturedimage(e.target.value)} />
                </Form.Group>
                <Form.Group as={Col} controlId="featuredicon">
                  <Form.Label>Featured Icon Name:</Form.Label>
                  <Form.Control type="text" value={featuredicon} onChange={(e) => setFeaturedicon(e.target.value)} />
                </Form.Group>
              </Row>

              {/* Form Actions */}
              <div className="form-actions">
                <button type="submit" className="btn-gradient-success">
                  Publish Post
                </button>
                <Link to="/blogslist" className="btn-back-link">
                  ← Back to List
                </Link>
              </div>
            </Form>
          </div>
        </div>

        <ToastContainer />

        {/* Create Confirmation Modal */}
        <Modal show={showCreateModal} onHide={() => setShowCreateModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Create New Blog</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to publish this blog post?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowCreateModal(false)}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleCreate}>
              Publish
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};

export default CreateBlog;